import Paper from '@mui/material/Paper';
import excelImage from '../../../../../assets/images/excel_image.png';
import { useTranslation } from "react-i18next";
import { MCButton } from "../../../../MainComponents";

import './Cards.scss'

const formatDates = (date) => {
  const objectDate = new Date(date);
  const day = objectDate.getDate();
  const month = objectDate.getMonth() + 1;
  const year = objectDate.getFullYear();

  return `${day}/${month}/${year}`;
};

export const ButtonsControl = ({ buttonsInformation }) => {

    return (
    <div className="buttons-control">
      {buttonsInformation.map((buttonInformation, index) => {

        return (
          <MCButton
            key={index}
            label={buttonInformation.label}
            style={buttonInformation.style}
            variant={buttonInformation.variant}
            onClick={buttonInformation.onClick}
            outline={buttonInformation.outline}
            disabled={buttonInformation.disabled}
          />
        );
      })}
    </div>
  );
};

export const SmallCard = ({
  item,
  openModalFromDetail,
  controlsComponent,
  title,
}) => {
  const [t] = useTranslation("exports");

  return (
    <>
      <Paper
        key={item.alias}
        className="rectangle-card"
        sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
        elevation={4}
      >
        <img
          className="cursor"
          src={excelImage}
          alt="Excel"
          style={{ width: '80px', height: '80px', objectFit: 'cover' }}
          onClick={() => { openModalFromDetail(item, 'info') }}
        />
        <div className="rectangle-card-content">
          <h4 className="cursor" onClick={() => { openModalFromDetail(item, 'info') }}>
            {title}
          </h4>

          <div className="rectangle-card-information">
            <span className="">{item.range_date}</span>
            <span className="">
              {t("Exports.created_at")}: {formatDates(item.created_at)}
            </span>
          </div>
          {controlsComponent}
        </div>
      </Paper>
    </>
  );
};